<template><div><h1 id="auftragsstatistik" tabindex="-1"><a class="header-anchor" href="#auftragsstatistik"><span>Auftragsstatistik</span></a></h1>
<p>Auftragsstatistik — Aufträge und Umsätze nach Status</p>
<h2 id="beschreibung" tabindex="-1"><a class="header-anchor" href="#beschreibung"><span>Beschreibung</span></a></h2>
<p>Die Auswertung erstellt eine Statistik aus allen Aufträgen und zeigt fakturierte, reservierte, vorreservierte und stornierte Umsatzwerte auf. Es ist möglich, die Werte detailliert oder kumuliert auszugeben. Die Statistik zeigt auf Wunsch auch kumulative Werte für die einzelnen Auftrags- und Bestell- und Verarbeitungsarten.</p>
<p>Pfad: <code v-pre>Verkauf → Auswertungen → Auftragsstatistik</code></p>
<h2 id="parameter" tabindex="-1"><a class="header-anchor" href="#parameter"><span>Parameter</span></a></h2>
<p><strong>Parameter</strong></p>
<dl>
<dt>von Datum</dt>
<dd>Anfangsdatum der Statistik, massgebend dafür ist das Erfassungsdatum der Aufträge</dd>
<dt>bis Datum</dt>
<dd>Enddatum der Statistik, massgebend dafür ist das Erfassungesdatum der Aufträge</dd>
<dt>Auswerte-Stichtag</dt>
<dd>Stichtag der Auswertung</dd>
<dt>Auftragsart</dt>
<dd>mit Auftragsart, leer = alle</dd>
<dt>Bestellart</dt>
<dd>mit Bestellart, leer = alle</dd>
<dt>Verarb-Art</dt>
<dd>S = Schnellversand, P = Postexpress, N = Normalversand, W = Wiederverkäufer, NW = Normal und Wiederverkäufer, leer = alle</dd>
<dt>Umsätze abzüglich Rabatt</dt>
<dd>ja = Nettoumsätze mit Abzug von Rabatten, nein = Bruttoumsätze ohne Abzug von Rabatten</dd>
<dt>Drucksteuerung</dt>
<dd>T = Übersicht (Totale), D = Details</dd>
<dt>Ausgabe</dt>
<dd>Standard (Drucker: A4-Portrait)</dd>
</dl>
<h2 id="output-liste" tabindex="-1"><a class="header-anchor" href="#output-liste"><span>Output (Liste)</span></a></h2>
<p>Die Ausgabe beinhaltet die folgenden Spalten:</p>
<table>
<thead>
<tr>
<th>Spalte</th>
<th>Bedeutung</th>
</tr>
</thead>
<tbody>
<tr>
<td>A-Art</td>
<td>Auftragsart</td>
</tr>
<tr>
<td>LA</td>
<td>Verarbeitungsart</td>
</tr>
<tr>
<td>BestArt</td>
<td>Bestellart</td>
</tr>
<tr>
<td>Auftrag Total</td>
<td>Anzahl Aufträge gesamt</td>
</tr>
<tr>
<td>Umsatz fakturiert</td>
<td>Wert fakturierter Auftragspositionen Total inkl. MWSt., beinhaltet aber keine Spenden und auch kein Porto</td>
</tr>
<tr>
<td>Umsatz nichtfakturiert</td>
<td>Wert nicht fakturierter Auftragspositionen Total, beinhaltet auch Umsätze von reservierten und vorreservierten Auftragspositionen.</td>
</tr>
<tr>
<td>Umsatz reserviert</td>
<td>Wert reservierter Auftragspositionen Total</td>
</tr>
<tr>
<td>Umsatz vor-res</td>
<td>Wert vorreservierter Auftragspositionen Total</td>
</tr>
<tr>
<td>Umsatz ret-stor</td>
<td>Wert retournierter oder stornierter Positionen Total (kumuliert)</td>
</tr>
<tr>
<td>Umsatz Spenden</td>
<td>Betrag der auf dem Bestellschein versprochenen Spende - Total (kumuliert)</td>
</tr>
</tbody>
</table>
<div class="hint-container tip">
<p class="hint-container-title">Anmerkung</p>
<p>Spendeartikel sind in dieser Statistik separat aufgeführt.</p>
</div>
<p>Dieses Beispiel zeigt die Statistik ohne Details.</p>
<div class="language-text line-numbers-mode" data-highlighter="prismjs" data-ext="text"><pre v-pre><code><span class="line">Datenausgabe                          28.11.2003 13:43:25 svw  Seite     0</span>
<span class="line"></span>
<span class="line">Datum: 01.09.2003 - 28.11.2003 Auswerte-Stichtag: 28.11.2003</span>
<span class="line">Auftragsart:     Bestart.:          Lieferart:    Umsätze abzüglich Rabatt: nein</span>
<span class="line"></span>
<span class="line"></span>
<span class="line">A-  L Best  Auftrag   Umsatz     Umsatz    Umsatz     Umsatz    Umsatz</span>
<span class="line">Art A Art    Total  fakturiert reserviert  vor-res    ret-stor  Spenden</span>
<span class="line">--- - ----- ------- ---------- ---------- --------- ---------- ---------</span>
<span class="line">ab  N TotLA      47        714         23        12          0        50</span>
<span class="line"></span>
<span class="line">ab    TotAA      47        714         23        12          0        50</span>
<span class="line"></span>
<span class="line">ac  N TotLA       9      2'530          0         0        745         0</span>
<span class="line"></span>
<span class="line">ac  S TotLA       2        245          0         0          0         0</span>
<span class="line"></span>
<span class="line">ac    TotAA      11      2'530          0         0        745         0</span>
<span class="line"></span>
<span class="line">      Tot-G      56      2'775         23        12        745        50</span>
<span class="line"></span></code></pre>
<div class="line-numbers" aria-hidden="true" style="counter-reset:line-number 0"><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div></div></div><p>47 Aufträge der Auftragsart ab wurden in der betrachteten Periode erfasst. Der Umsatz der fakturierten Aufträge beträgt 714 CHF, der reservierten 23 CHF, der vorreservierten 12 CHF. Der Anteil der Spenden in diesen Aufträgen beträgt 50 CHF. In der Auftragsart ac sind 11 Aufträge eingegangen, 2 davon mit Schnellversand, die anderen mit normaler Lieferoption. In dieser Auftragsart wurden Ware im Wert von 745 CHF retourniert.</p>
<p>Dieses Beispiel zeigt den Output mit Details.</p>
<div class="language-text line-numbers-mode" data-highlighter="prismjs" data-ext="text"><pre v-pre><code><span class="line">Datenausgabe                          28.11.2003 14:41:13 svw  Seite     0</span>
<span class="line"></span>
<span class="line">Datum: 01.09.2003 - 28.11.2003 Auswerte-Stichtag: 28.11.2003</span>
<span class="line">Auftragsart:     Bestart.:          Lieferart:    Umsätze abzüglich Rabatt: nein</span>
<span class="line"></span>
<span class="line"></span>
<span class="line">A-  L Best  Auftrag   Umsatz     Umsatz    Umsatz     Umsatz    Umsatz</span>
<span class="line">Art A Art    Total  fakturiert reserviert  vor-res    ret-stor  Spenden</span>
<span class="line">--- - ----- ------- ---------- ---------- --------- ---------- ---------</span>
<span class="line">ab  N E-Ma       12        157         23         0          0        50</span>
<span class="line">ab  N fax        35        557          0        12          0         0</span>
<span class="line">ab  N TotLA      47        714         23        12          0        50</span>
<span class="line"></span>
<span class="line">ab    TotAA      47        714         23        12          0        50</span>
<span class="line"></span>
<span class="line">ac  N fax         9      2'530          0         0        745         0</span>
<span class="line">ac  N TotLA       9      2'530          0         0        745         0</span>
<span class="line"></span>
<span class="line">ac  S fax         2        245          0         0          0         0</span>
<span class="line">ac  S TotLA       2        245          0         0          0         0</span>
<span class="line"></span>
<span class="line">ac    TotAA      11      2'530          0         0        745         0</span>
<span class="line"></span>
<span class="line">      Tot-G      56      2'775         23        12        745        50</span>
<span class="line"></span></code></pre>
<div class="line-numbers" aria-hidden="true" style="counter-reset:line-number 0"><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div></div></div><p>Mit der Auftragsart ab sind insgesamt 12 Aufträge per E-Mail und 35 Aufträge per Fax eingegangen. Mit der Auftragsart ac sind insgesamt 11 Aufträge per Fax eingegangen wovon 2 mit Schnellversand geliefert wurden. Bei den Umsätzen handelt es sich um Bruttozahlen da die Option &quot;Umsätze abzüglich Rabatt&quot; nein gewählt wurde.</p>
<p>Dieses Beispiel zeigt den Output mit Details. Die Auswertung wurde mit einem zurückliegenden Auswerte-Stichtag erstellt.</p>
<div class="language-text line-numbers-mode" data-highlighter="prismjs" data-ext="text"><pre v-pre><code><span class="line">Datenausgabe                          28.11.2003 15:07:34 svw  Seite     0</span>
<span class="line"></span>
<span class="line">Datum: 01.09.2003 - 28.11.2003 Auswerte-Stichtag: 31.10.2003</span>
<span class="line">Auftragsart:     Bestart.:          Lieferart:    Umsätze abzüglich Rabatt: nein</span>
<span class="line"></span>
<span class="line"></span>
<span class="line">A-  L Best  Auftrag   Umsatz          Umsatz     Umsatz    Umsatz</span>
<span class="line">Art A Art    Total  fakturiert nichtfakturiert   ret-stor  Spenden</span>
<span class="line">--- - ----- ------- ---------- --------------- ---------- ---------</span>
<span class="line">ab  N E-Ma       12         95              85          0        50</span>
<span class="line">ab  N fax        35        432             137          0         0</span>
<span class="line">ab  N TotLA      47        527             222          0        50</span>
<span class="line"></span>
<span class="line">ab    TotAA      47        527             222          0        50</span>
<span class="line"></span>
<span class="line">ac  N fax         9        450           2'080        745         0</span>
<span class="line">ac  N TotLA       9        450           2'080        745         0</span>
<span class="line"></span>
<span class="line">ac  S fax         2        245               0          0         0</span>
<span class="line">ac  S TotLA       2        245               0          0         0</span>
<span class="line"></span>
<span class="line">ac    TotAA      11        695           2'080        745         0</span>
<span class="line"></span>
<span class="line">      Tot-G      56      1'222           2'302        745        50</span>
<span class="line"></span></code></pre>
<div class="line-numbers" aria-hidden="true" style="counter-reset:line-number 0"><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div></div></div><p>Diese Auswertung zeigt den Stand der Umsätze am 31.10.2003, da als Auswerte-Stichtag dieses Datum gewählt wurde. Die Spalte Umsatz nichtfakturiert zeigt alle noch nicht fakturierten Aufträge inkl. der Umsätze von reservierten und vorreservierten Artikeln im angegebenem Zeitraum.</p>
</div></template>


